import { SellLocation } from "./search/sell/location/SellLocation";
// @ts-ignore
import $ from "jquery";
import "slick-carousel";
import "./style.sass";
import { Front } from "./front/Front";
import { Basic } from "./basic/Basic";
import { SellPropertyType } from "./search/sell/propertyType/SellPropertyType";
import { SellValue } from "./search/sell/value/SellValue";
import { SellTimeframe } from "./search/sell/timeframe/SellTimeframe";
import { SellBuy } from "./search/sell/buy/SellBuy";
import { SellContact } from "./search/sell/contact/SellContact";
import { BuyLocation } from "./search/buy/location/BuyLocation";
import { BuyValue } from "./search/buy/value/BuyValue";
import { BuyPropertyType } from "./search/buy/propertyType/BuyPropertyType";
import { BuyTimeframe } from "./search/buy/timeframe/BuyTimeframe";
import { BuySell } from "./search/buy/sell/BuySell";
import { BuyContact } from "./search/buy/contact/BuyContact";
import { Brokers } from "./brokers/Brokers";
import { Thanks } from "./thanks/Thanks";
import { HomeEstimate } from "./home-estimate/HomeEstimate";
var Index = /** @class */ (function () {
    function Index() {
        var _this = this;
        this.types = {
            sellLocation: SellLocation,
            sellPropertyType: SellPropertyType,
            sellValue: SellValue,
            sellTimeframe: SellTimeframe,
            sellBuy: SellBuy,
            sellContact: SellContact,
            buyLocation: BuyLocation,
            buyValue: BuyValue,
            buyTimeframe: BuyTimeframe,
            buySell: BuySell,
            buyContact: BuyContact,
            buyPropertyType: BuyPropertyType,
            brokers: Brokers,
            thanks: Thanks,
            front: Front,
            basic: Basic,
            estimate: HomeEstimate
        };
        this.window = $(window);
        this.mainEl = $("main");
        this.footerEl = $("footer");
        this.searchNavBarEl = $("#search-nav-bar");
        this.headerNavEl = $("header nav ul");
        this.headerNavWidth = this.headerNavEl.outerWidth();
        $(".hamburger-menu, .menu-toggle").on("click", function () {
            if ($("html").hasClass("has-overlay")) {
                $("html").removeClass("has-overlay");
            }
            else {
                $("html").addClass("has-overlay");
            }
        });
        $(document).ready(function () {
            _this.go();
        });
        $(window).resize(function () {
            _this.resize();
            _this.inputs();
        });
        this.inputs();
    }
    Index.prototype.go = function () {
        var Controller = this.types[window.pageData.type];
        if (Controller) {
            new Controller;
        }
        this.resize();
        $("html, body").addClass("go-loaded");
    };
    Index.prototype.resize = function () {
        this.windowWidth = this.window.width();
        this.windowHeight = this.window.height();
        this.footerHeight = this.footerEl.outerHeight();
        this.searchNavHeight = this.searchNavBarEl.outerHeight();
        this.resizeContent();
    };
    Index.prototype.resizeContent = function () {
        if ((this.windowWidth * 0.9) - 200 < this.headerNavWidth) {
            $("body").addClass("compact-nav");
        }
        else {
            $("body").removeClass("compact-nav");
            $("html").removeClass("has-overlay");
        }
        if (this.searchNavBarEl.length) {
            var minHeight = this.windowHeight - this.searchNavHeight;
            this.mainEl.css({
                minHeight: minHeight
            });
            this.footerEl.css({
                paddingBottom: this.searchNavHeight + 10
            });
        }
        else {
            var minHeight = this.windowHeight - this.footerHeight;
            this.mainEl.css({
                minHeight: minHeight
            });
        }
    };
    Index.prototype.inputs = function () {
        var inputs = $("input.js-input:not(.always-has-value)");
        inputs.on("keyup", function () {
            var el = $(this);
            var val = el.val();
            if (val != "") {
                el.addClass("js-input-active");
            }
            else {
                el.removeClass("js-input-active");
            }
        });
        inputs.on("blur", function () {
            var el = $(this);
            var val = el.val();
            if (val != "") {
                el.addClass("js-input-has-value");
            }
            else {
                el.removeClass("js-input-has-value");
            }
        });
        inputs.each(function () {
            var el = $(this);
            var val = el.val();
            if (val != "") {
                el.addClass("js-input-has-value");
            }
            else {
                el.removeClass("js-input-has-value");
            }
        });
    };
    return Index;
}());
new Index;
